import {
    faEllipsisVertical,
    faPlus,
    faFileExport,
    faFileCsv,
    faUser,
} from "@fortawesome/free-solid-svg-icons"
import {
    Button,
    Dropdown,
    Nav,
} from "react-bootstrap"
import {
    handleExportData,
} from "../../../Utils/helpers/commonhelper"
import { Filter } from "../../../CommonComponents/Filter"
import { FilterPagination } from "../../../CommonComponents/FIlterPagination"
import { DropdownItemWithActions } from "../../../CommonComponents/DropdownItemWithActions"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnConfigurator } from "../../../CommonComponents/ColumnConfigurator";
import { DeleteRequest, GetRequest, PutRequest } from "../../../Utils/hooks/ApiHandler"
import DeleteModal from "../../DeleteModal"
import { useNavigate } from "react-router-dom"
import { useEffect, useRef, useState } from "react"
import useLocalStorageState from "use-local-storage-state"
import { toast } from "sonner"
import { ManageListDropdown } from "../../../CommonComponents/ManageListDropdown"
import { useGetEssentials } from "../../../Utils/hooks/useGetEssentials"
import { FilterQueryString } from "../../../CommonComponents/FilterQueryString"

export const SalesHeader = ({
    isMyApproval,
    setMyApproval,
    heading,
    setHeading,
    columns,
    setColumns,
    columnOptions,
    filterStates,
    setFilterState,
    filterCategories,
    setFilterCategories,
    filterOffset,
    setFilterOffset,
    setTempFilterData,
    setCurrAdvFilter,
    setActiveOffset,
    setSearch,
    setCustomFilter,
    refetchSales,
    salesOrderMetadata,
    dropdownOptions,
    filterDropdown,
    setFilterDropdown,
    filterValues,
    setSalesFilterValues
}) => {

    const { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType } = useGetEssentials()

    // rbac permission object
    const [PERMISSION, _] = useLocalStorageState('permission')

    // sales permission
    const salesGrant = PERMISSION.sales_order

    // state for heading to display
    const lastHeading = localStorage.getItem("sales_last_heading")
    // filter seazrch bar input state
    const [filterSearchInput, setFilterSearchInput] = useState("")

    // fitered categories to store the search input filter categories
    const [filteredCategories, setFilteredCategories] = useState([])

    const [inputSearch, setInputSearch] = useState("")

    // for dropdown of the filter cards being created by the user
    const [filterCategoriesDropdown, setFilterCategoriesDrop] = useState(false)
    const filterCategoriesDropRef = useRef(null)
    // filter state to store the data to pass to delete and edit handler for filter
    const [filterData, setFilterData] = useState(null)
    // edit value state fot the filter card name edit
    const [editValue, setEditValue] = useState()
    // delete state for filter
    const [confirmFilterDelete, setFilterDelete] = useState(false)
    // isediting state for undoing the edit state in the filter name update in the heading dropdown
    const [editingId, setEditingId] = useState(false)

    const [filterLimit, setFilterLimit] = useState(5)
    const [debouncedFilterSearch, setDebouncedFilterSearch] = useState("")
    const [filterPageCount, setFilterPageCount] = useState(0)

    // heading filter dropdown static options
    const salesStaticListOptions = [
        {
            key: "All Sales Order",
            icon: <FontAwesomeIcon
                icon={faUser}
                style={{ width: "13px", height: "13px", marginRight: "9px" }}
            />
        }
    ]

    // sub filter dropdown option
    const subFilter = [
        { value: "equals", label: "Equals" },
        { value: "not_equals", label: "Not-Equals" },
        { value: "contains", label: "Contains" },
        { value: "not_contains", label: "Not-Contains" },
        { value: "in", label: "In" },
        { value: "not_in", label: "Not-In" },
        { value: "is_empty", label: "Is Empty" },
        { value: "is_not_empty", label: "Is Not Empty" },
        { value: "begins_with", label: "Begins With" },
        { value: "between", label: "Between" },
    ]
    const customSubFilter = [
        { value: "equals", label: "Equals" },
        { value: "not_equals", label: "Not-Equals" },
        { value: "is_set", label: "Is Set" },
        { value: "is_not_set", label: "Is Not Set" },
        { value: "in", label: "In" },
        { value: "not_in", label: "Not-In" },
    ]



    // Debounced search effect
    useEffect(() => {
        const debounceTimer = setTimeout(() => {
            setSearch(inputSearch.trim())
            setActiveOffset(0)
        }, 300)
        return () => clearTimeout(debounceTimer)
    }, [inputSearch])

    useEffect(() => {
        if (!filterSearchInput || filterSearchInput.trim() === "") {
            // If no search input, show all categories
            setFilteredCategories(filterCategories)
        } else {
            // Filter categories based on search input
            const filtered = filterCategories.filter((category) =>
                category.card_name
                    .toLowerCase()
                    .includes(filterSearchInput.toLowerCase())
            )
            setFilteredCategories(filtered)
        }
    }, [filterSearchInput, filterCategories])

    // useeeffect for fetching the created advance filters
    const fetchFilterCardCategories = async () => {
        try {
            const res = await GetRequest(
                `common/fetchFilterCard/${customerId}/sales_order/${loginUserId}?offset=${filterOffset}&limit=${filterLimit}&search=${debouncedFilterSearch}`,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            )

            if (res.status === "fail" || res.success === false) {
                return
            }

            setFilterCategories(res.data)

            // Calculate page count if total_count is available in response
            if (res.total_count) {
                setFilterPageCount(Math.ceil(res.total_count / filterLimit))
            }
        } catch (error) {
            toast.error("Error fetching filters")
        }
    }
    useEffect(() => {
        fetchFilterCardCategories()
    }, [heading, filterOffset, filterLimit, debouncedFilterSearch])

    // edit handler for filter heading
    const handleFilterEdit = async () => {
        try {
            if (!editValue?.trim()) return
            if (!filterData) return

            const updatePayload = {
                customer_id: customerId,
                user_login_id: loginUserId,
                filter_id: filterData.id,
                card_name: editValue,
                description: "",
                module_name: "sales_order"
            }
            const res = await PutRequest(
                "common/updateFilterName",
                updatePayload,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            )

            if (res?.status === "fail" || res?.success === false) {
                toast.error(res?.message || "Error Updating Filter")
                setFilterDropdown(false)
                return
            }

            setHeading(editValue.trim())
            // setIsEditing(false)
            setEditingId(null)
            setFilterDropdown(false)
            fetchFilterCardCategories()
            toast.success(res?.message)
        } catch (error) {
            toast.error("Error Updating Filter")
        }
    }
    // delete handler for filter delete
    const handleFilterDelete = async () => {
        try {
            if (filterData === null) return
            const res = await DeleteRequest(
                `common/deleteFilter/${filterData.id}`,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            )
            if (res.status === "fail") {
                toast.error(res.message)
                return
            }
            if (res.success === false) {
                toast.error(res.message)
            }
            setCustomFilter(null)
            setFilterDropdown(false)
            setFilterDelete(false)

            setHeading("All Sales Order")
            filterCategories?.length !== 1 && fetchFilterCardCategories()
            filterCategories?.length === 1 && setFilterOffset(0)
            refetchSales()
            localStorage.setItem("salesOrderMetadata", JSON.stringify({
                ...salesOrderMetadata,
                filterType: {
                    filterName: "All Sales Order",
                    id: null
                }
            }))
            toast.success(res.message)
        } catch (error) {
            toast.error("Error Deleting Filter")
        }
    }

    return (
        <>
            <div className="py-0 pb-1 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                    <h3
                        className="mb-0 d-flex gap-2 align-items-center"
                        style={
                            isMyApproval
                                ? {
                                    cursor: "pointer",
                                    color: "#7991a1ff",
                                    fontSize: "1.2rem",
                                    fontWeight: 300,
                                    textTransform: "capitalize"
                                }
                                : {
                                    whiteSpace: "nowrap",
                                    fontWeight: 300,
                                    fontSize: "1.2rem",
                                    cursor: "pointer",
                                    textTransform: "capitalize",
                                    color: "#4dabf4",
                                }
                        }
                        onClick={() => {
                            setMyApproval(false);
                        }}
                    >
                        {heading}
                    </h3>

                    <ManageListDropdown
                        heading={heading}
                        setHeading={setHeading}
                        categories={filterCategories}
                        storageKey="salesOrderMetadata"
                        metadata={salesOrderMetadata}
                        setTempFilterData={setTempFilterData}
                        onEdit={(c) => setFilterData(c)}
                        onDelete={(c) => {
                            setFilterData(c)
                            setFilterDelete(true)
                        }}
                        onUpdate={(c) => {
                            setFilterData(c)
                            handleFilterEdit()
                        }}
                        staticOptions={salesStaticListOptions}
                        filterOffset={filterOffset}
                        setFilterOffset={setFilterOffset}
                        handleFilterPageChange={(newOffset) => setFilterOffset(newOffset.selected)}
                        filterPageCount={filterPageCount}
                        filterLimit={filterLimit}
                        editValue={editValue}
                        setEditValue={setEditValue}
                        editingFilterId={editingId}
                        setEditingFilterId={setEditingId}
                        canEdit_canDownload={true}
                        setCustomFilter={setCustomFilter}
                        filterQueryKey={"salesApplyFilterQueryValues"}
                        setCurrAdvFilter={setCurrAdvFilter}
                    />

                    <p
                        style={{ width: 1, height: 25, background: "lightblue" }}
                        className="mb-0"
                    ></p>
                    <span
                        style={
                            isMyApproval
                                ? {
                                    whiteSpace: "nowrap",
                                    fontWeight: 300,
                                    cursor: "pointer",
                                    color: "#4dabf4",
                                }
                                : {
                                    cursor: "pointer",
                                    color: "#7991a1ff",
                                    fontWeight: 300,
                                }
                        }
                        onClick={() => setMyApproval(true)}
                    >
                        <span style={{ fontSize: "1.2rem" }}> My Approvals</span>
                    </span>

                    {confirmFilterDelete && (
                        <DeleteModal
                            show={confirmFilterDelete}
                            onClose={() => setFilterDelete(false)}
                            onConfirm={() => handleFilterDelete(filterData)}
                        ></DeleteModal>
                    )}
                </div>

                <div
                    className="d-flex align-items-center gap-1"
                    style={{
                        height: "35px",
                        position: "absolute",
                        right: 0,
                        top: "-3.5rem",
                    }}
                >
                    {/* search bar */}
                    <div className=" position-relative">
                        <input
                            type="text"
                            style={{
                                fontSize: "12px",
                                paddingLeft: "36px",
                                height: "35px",
                            }}
                            className="form-control "
                            value={inputSearch}
                            onChange={(e) => {
                                setInputSearch(e.target.value)
                                setActiveOffset(0)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault()
                                    setSearch(inputSearch)
                                    setActiveOffset(0)
                                }
                            }}
                        />
                        <i
                            className="fa-solid fa-magnifying-glass"
                            style={{
                                position: "absolute",
                                marginTop: "-26px",
                                zIndex: 1,
                                marginLeft: "13px",
                            }}
                        ></i>
                        {inputSearch.length > 0 && (
                            <i
                                className="fa-solid fa-xmark"
                                style={{
                                    position: "absolute",
                                    marginTop: "-26px",
                                    zIndex: 1,
                                    right: 0,
                                    marginRight: "13px",
                                    cursor: "pointer",
                                }}
                                onClick={() => setInputSearch("")}
                            ></i>
                        )}
                    </div>

                    {/* advance filtering */}
                    <Filter
                        canEdit_canDownload={true}
                        filterDropdown={filterDropdown}
                        setFilterDropdown={setFilterDropdown}
                        dropdownOptions={dropdownOptions}
                        filterState={filterStates}
                        setFilterState={setFilterState}
                        setHeading={setHeading}
                        subFilter={subFilter}
                        module_name={"sales_order"}
                        customSubFilter={customSubFilter}
                        setTempFilterData={setTempFilterData}
                        setCurrAdvFilter={setCurrAdvFilter}
                        filterEndpoint={"common/filterQuery"}
                        view={"list"}
                        setOffset={setActiveOffset}
                        setCustomFilter={setCustomFilter}
                        storageKey={'salesOrderMetadata'}
                        metadata={salesOrderMetadata}
                        filterQueryKey={'salesApplyFilterQueryValues'}
                    ></Filter>

                    <ColumnConfigurator
                        columnOptions={columnOptions}
                        columns={columns}
                        setColumns={setColumns}
                        storageKey="salesOrderMetadata"
                        metadata={salesOrderMetadata}
                    />

                    <Dropdown
                        as="div"
                        className="dropdownsWithoutToggle"
                        style={{ zIndex: 101 }}
                    >
                        <Dropdown.Toggle as={Nav.Link} className="header-link">
                            <button
                                className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                                style={{
                                    fontSize: "1rem",
                                    alignItems: "center",
                                    height: "35px",
                                    width: "2.5rem",
                                }}
                            >
                                {" "}
                                <FontAwesomeIcon
                                    style={{
                                        width: "15px",
                                        height: "15px",
                                    }}
                                    icon={faEllipsisVertical}
                                />
                            </button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                            className="defaultDropdown dropdown-menu-end "
                            style={{
                                width: "11rem",
                                padding: "12px 0px",
                                right: "3.4rem",
                            }}
                        >
                            {/* <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() => {
                                 if (!salesGrant?.isImport) {
                                   toast.warning("You are not authorized for this action!");
                                   return;
                                 }
                                 navigate("/importdata", {
                                   state: {
                                     module_name: "sales_order",
                                     fieldData: [
                                       {
                                         title: "General Fields",
                                         fields: salesOrderImportFields.map((c) => c),
                                       },
                                     ],
                                   },
                                 });
                               }}
                    >
                      <FontAwesomeIcon
                        icon={faFileImport}
                        style={{
                          width: "16px",
                          height: "16px",
                          marginRight: "9px",
                          color: "#5e5f60",
                        }}
                      />{" "}
                      Import Data
                    </Dropdown.Item> */}
                            <Dropdown.Item
                                className="d-flex align-items-center"
                                onClick={() => {
                                    if (!salesGrant.isExport) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                    }
                                    handleExportData([], "sales_order", headers, extras)
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={faFileExport}
                                    style={{
                                        width: "16px",
                                        height: "16px",
                                        marginRight: "9px",
                                        color: "#5e5f60",
                                    }}
                                />{" "}
                                Export Data
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    {/* <Button
                  type="button"
                  className="btn btn-default"
                  style={{maxHeight:"35px",
              color:"white",
              fontSize:"14px",
              border:"1px solid",
              alignItems:"center",
              paddingRight:"10px",
              backgroundColor:"rgb(122, 58, 94)"
            }}
 
                  onClick={() =>
                    navigate("/createSalesOrder", {
                      state: {
                        contact_id: null,
                        deal_id: null,
                        quotation_id: null,
                      },
                    })
                  }
                >
                  <FontAwesomeIcon icon={faPlus} /> Add
                </Button> */}
                    <Button
                        type="button"
                        className="btn btn-default"
                        style={{
                            height: "34px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onClick={() => {
                            if (!salesGrant?.isCreate) {
                                toast.warning("You are not authorized for this action")
                                return
                            }
                            navigate("/createSalesOrder", {
                                state: {
                                    contact_id: null,
                                    deal_id: null,
                                    quotation_id: null,
                                },
                            })
                        }}
                    >
                        <FontAwesomeIcon icon={faPlus} className="pe-1" /> Add
                    </Button>
                </div>
            </div>
            {/* to show the current applied filters  */}
            <FilterQueryString
                filterValues={filterValues}
                setCurrAdvFilter={setCurrAdvFilter}
                setTempFilterData={setTempFilterData}
                setFilterState={setFilterState}
                setFilterValues={setSalesFilterValues}
            />
        </>
    )
}
